import React from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { IOperatorsDTO } from '../../api/operators.dao';
import { connectOperatorVM, OperatorsContext } from './operator.context';
import { OperatorsVM } from './operators.viewmodel';
import { FullOperatorsList } from './_operator-list/operators-list';

interface IProps {
    operatorsList: IOperatorsDTO[];
    isLoading: boolean;
}

const OperatorsDisconnected = props => {
    if (props.isLoading) {
        return <div>Loading...</div>;
    } else
        return <FullOperatorsList />;
};

const OperatorsConnected = connectOperatorVM<IProps>(OperatorsDisconnected, vm => {
   return {
    operatorsList: vm.operatorsList,
    isLoading: vm.isLoading,
   };
});

const Operators = moduleHost(OperatorsVM, OperatorsContext, OperatorsConnected);

export { Operators };